module.exports = __webpack_public_path__ + "img/19_newModelWorker_zbw.47a05e41.png";